import React, { Fragment, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import ReportContent from '../../component/tableDrawer/reportContent'
import ReportHeader from '../../component/tableDrawer/reportHeader'
import ReportSearch from '../../component/tableDrawer/reportSearch'
import ImgPopup from '../../component/popups/imgPopup'
import { GetAllMedicalRequests } from '../../api/endpoints'
import BaseBtn from '../../component/tableDrawer/Tables/Components/TableActions/BaseBtn'

const UsersRequests = () => {
  const navigate = useNavigate()

  const columns = useMemo(() => [
    { Header: "id", accessor: "orderId" },
    { Header: "userName", accessor: "userName" },
  //  { Header: "medicalRecord", Cell: ({ row: { original } }) => <ImgPopup link={original?.medicalRecord} /> },
    { Header: "status", accessor: "orderStatus" },
    { Header: "orderDate", accessor: "orderDate" },
    {
      id: 'actions',
      Cell: ({ row: { original } }) =>
        <Fragment key={original.orderId}>
          <BaseBtn 
            action={"show-details"} 
            onApply={() => navigate(`/medical-request-details/${original.orderId}`)} 
            icon={"game-icons:beast-eye"} 
            className="info" 
            reqAction="canAdd" 
          />
        </Fragment>
    }
  ], [navigate])

  return (
    <>
      <ReportContent tableAPI={GetAllMedicalRequests} columns={columns}>
        <ReportHeader>
          <ReportSearch />
        </ReportHeader>
      </ReportContent>
    </>
  )
}

export default UsersRequests